import { Box, useTheme } from "@mui/material";

/** Ilustração SVG leve para o cabeçalho do painel de vendas (tema teal / slate). */
export function SalesAnalyticsHero(props: { height?: number }) {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const light = theme.palette.primary.light;
  const h = props.height ?? 160;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 420,
        mx: "auto",
        opacity: 0.95,
      }}
      aria-hidden
    >
      <svg
        viewBox="0 0 400 200"
        width="100%"
        height={h}
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="salesHeroGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={light} stopOpacity="0.9" />
            <stop offset="100%" stopColor={primary} stopOpacity="0.85" />
          </linearGradient>
          <linearGradient id="salesBarGrad" x1="0%" y1="100%" x2="0%" y2="0%">
            <stop offset="0%" stopColor={primary} stopOpacity="0.35" />
            <stop offset="100%" stopColor={light} stopOpacity="0.95" />
          </linearGradient>
          <filter id="softShadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="0" dy="4" stdDeviation="8" floodOpacity="0.12" />
          </filter>
        </defs>
        <rect
          x="24"
          y="28"
          width="352"
          height="120"
          rx="18"
          fill="#f8fafc"
          stroke="rgba(15,23,42,0.08)"
          filter="url(#softShadow)"
        />
        <path
          d="M44 118 L88 78 L132 96 L176 52 L220 68 L264 44 L308 88 L352 58"
          fill="none"
          stroke="url(#salesHeroGrad)"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {[44, 88, 132, 176, 220, 264, 308].map((x, i) => (
          <circle
            key={i}
            cx={x}
            cy={[118, 78, 96, 52, 68, 44, 88][i]}
            r="5"
            fill={primary}
            stroke="#fff"
            strokeWidth="2"
          />
        ))}
        <g transform="translate(48 148)">
          {[0, 1, 2, 3, 4].map((i) => (
            <rect
              key={i}
              x={i * 56}
              y={32 - [12, 22, 16, 26, 18][i]}
              width="28"
              height={[12, 22, 16, 26, 18][i]}
              rx="4"
              fill="url(#salesBarGrad)"
            />
          ))}
        </g>
        <circle cx="320" cy="40" r="36" fill={primary} opacity="0.12" />
        <path
          d="M308 36 L328 36 L328 56 L312 56 L308 52 Z"
          fill={primary}
          opacity="0.5"
        />
        <text
          x="48"
          y="52"
          fontFamily="system-ui, sans-serif"
          fontSize="13"
          fontWeight="700"
          fill="#0f172a"
        >
          Desempenho
        </text>
        <text
          x="48"
          y="70"
          fontFamily="system-ui, sans-serif"
          fontSize="10"
          fill="#64748b"
        >
          Receita e volume
        </text>
      </svg>
    </Box>
  );
}
